import React from 'react';
import { DOMAIN, NAME } from '../mock';

export default function Footer() {
  return (
    <footer
      className="pt-16 pb-10"
      style={{ background: 'var(--bone-soft)', borderTop: '1px solid rgba(15,27,20,0.08)' }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div
          className="display select-none"
          style={{
            fontSize: 'clamp(3.5rem, 14vw, 13rem)',
            lineHeight: 0.9,
            fontWeight: 400,
            color: 'var(--forest)',
            letterSpacing: '-0.03em',
          }}
        >
          hey<em className="italic" style={{ color: 'var(--terracotta)' }}>sirin</em>.
        </div>

        <div className="mt-10 flex flex-wrap items-end justify-between gap-6 pt-6 border-t" style={{ borderColor: 'rgba(15,27,20,0.08)' }}>
          <div className="mono text-[11px] uppercase tracking-[0.18em] leading-relaxed" style={{ color: 'var(--moss)' }}>
            © {new Date().getFullYear()} {NAME} · {DOMAIN}
            <br />
            <span style={{ color: 'var(--stone)' }}>Yes, it’s spelled with an n.</span>
          </div>
          <div className="mono text-[11px] uppercase tracking-[0.18em] text-right" style={{ color: 'var(--moss)' }}>
            Designed & built by Sirin
            <br />
            <span style={{ color: 'var(--stone)' }}>Fraunces · Inter · JetBrains Mono</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
